// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"
import "./controllers";
import "./stream_actions";

// The two following lines disable Turbo on the whole application
import { Turbo } from "@hotwired/turbo-rails"
// Turbo.session.drive = false

Turbo.setConfirmMethod((message, element, button) => {
  let title = element.dataset.turboConfirmTitle
  let dialog = document.getElementById("turbo-confirm")
  let commitButton = dialog.querySelector("button[value='confirm']")
  let params = element.dataset.turboConfirmParams

  if (title){
    dialog.querySelector("[data-behavior='title']").textContent = title
  }

  if (params){
    dialog.querySelector("[data-behavior='params']").textContent = params
  }

  dialog.querySelector("[data-behavior='description']").innerHTML = message

  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue === "confirm")
    }, { once: true })
  })
})

document.addEventListener("turbo:frame-missing", (event) => {
  const { detail: { response, visit } } = event;
  event.preventDefault();
  visit(response.url);
});

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))